import 'magnific-popup'
import 'magnific-popup/dist/magnific-popup.css'
import $ from 'jquery'

export default class {

  constructor(el) {
    this.$el = $(el)
  }

  init() {
    this.$el.magnificPopup({
      type: 'iframe',
    })
  }

}
